import { render, staticRenderFns } from "./DisplayItem.vue?vue&type=template&id=2d48f89a&"
import script from "./DisplayItem.vue?vue&type=script&lang=ts&"
export * from "./DisplayItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports